import { render, staticRenderFns } from "./PosPermissionSelector.vue?vue&type=template&id=8bdb0114&scoped=true"
import script from "./PosPermissionSelector.vue?vue&type=script&lang=js"
export * from "./PosPermissionSelector.vue?vue&type=script&lang=js"
import style0 from "./PosPermissionSelector.vue?vue&type=style&index=0&id=8bdb0114&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdb0114",
  null
  
)

export default component.exports